




























































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

import Loading from '@/components/base/Loading.vue';
import toast from '@/components/toast';
import { ToastType } from '@/components/toast/tost-type.enum';
import SessionStore from '@/store/session.module';

import { Credential } from '../models/credential';

@Component({
  components: {
    Loading,
  },
})
export default class LoginForm extends Vue {
  private showPassword: boolean = false;

  private isLoading: boolean = false;

  private credentials: Credential = {
    email: '',
    password: '',
  };

  private async submit() {
    this.isLoading = true;

    return getModule(SessionStore, this.$store)
      .login(this.credentials)
      .then(() => {
        this.$router.replace({
          name: 'home',
          append: false,
          replace: true,
        });
        toast('Bem-vindo!', ToastType.SUCESS);
      })
      .finally(() => (this.isLoading = false));
  }

  get year() {
    return new Date().getFullYear();
  }
}
